// this is an extra file so it can be imported first
import { LOGGER_DEFAULT_CONFIG } from 'besonders-logger'

LOGGER_DEFAULT_CONFIG.time = true
// LOGGER_DEFAULT_CONFIG.delta = true
